import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Button,
  Select,
  Box
} from '@chakra-ui/react';
import { CreateAdminUsersApi } from '../../../../apis/CreateMaintenance.api';
import { CustomNumberInput } from '../../../atoms/CustomNumberInput';
import {
  BanInputType,
  CustomStringInput
} from '../../../atoms/CustomStringInput';
import { AdminUsersType } from '../Table/MaintenanceAdminUsersTable';
import { AxiosError } from 'axios';

const MinPassword = 10;

interface props {
  isOpen: boolean;
  onClose: () => void;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<AdminUsersType[] | undefined>
  >;
  CreateOrUpdateStateSwitch: () => void;
}

const GetCrewNumberInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { ViewInt: 10, ViewDigit: 0, Value: '' };
  }
  return { ViewInt: 10, ViewDigit: 0, Value: addData };
};

const GetCrewNameInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { Length: 300, BanInputType: BanInputType.None, Value: '' };
  }
  return { Length: 300, BanInputType: BanInputType.None, Value: addData };
};

const GetFuriganaInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { Length: 300, BanInputType: BanInputType.None, Value: '' };
  }
  return { Length: 300, BanInputType: BanInputType.None, Value: addData };
};

const GetPasswordInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { Length: 40, BanInputType: BanInputType.FullWidth, Value: '' };
  }
  return { Length: 40, BanInputType: BanInputType.FullWidth, Value: addData };
};

const CheckPassword = (
  password: string | undefined,
  checkPassword: string | undefined
) => {
  if (password === undefined || password === '') {
    alert('パスワードを入力して下さい。');
    return false;
  } else if (password !== checkPassword) {
    alert('パスワードの入力が一致しません。');
    return false;
  } else if (password?.length < MinPassword) {
    alert('パスワードは10桁以上で入力して下さい。');
    return false;
  } else if (
    !password?.match(
      /^(?=.*[a-z])(?=.*[0-9])(?=.*[!-/:-@¥[-`{-~])[a-z0-9!-/:-@¥[-`{-~]+$/
    )
  ) {
    alert('パスワードに半角英数字記号混合のみ登録可能です。');
    return false;
  }
  return true;
};

const AdminUsersCreateWindow: React.FC<props> = (props) => {
  const [crewNumber, setCrewNumber] = useState<string | undefined>('');
  const [crewName, setCrewName] = useState<string | undefined>('');
  const [furigana, setFurigana] = useState<string | undefined>('');
  const [password, setPassword] = useState<string | undefined>('');
  const [checkPassword, setCheckPassword] = useState<string | undefined>('');
  const [role, setRole] = useState(1);
  const { isOpen, onClose, setMaintenanceDatas, CreateOrUpdateStateSwitch } =
    props;

  const CreateApi = async () => {
    if (CheckPassword(password, checkPassword) === false) {
      return;
    }
    const response = await CreateAdminUsersApi({
      user_no: crewNumber,
      name: crewName,
      kana: furigana,
      password: password,
      role: role
    });

    if (
      response.message !== null &&
      (response.message as AxiosError).status?.toString() === '409'
    ) {
      alert('既に登録されている乗務員番号です。');
      return;
    } else if (response.success === false) {
      alert('登録に失敗しました。');
      return;
    }
    setMaintenanceDatas(response.data as AdminUsersType[]);
    CreateOrUpdateStateSwitch();
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='500px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            乗務員作成
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>乗務員番号*</Text>
              <CustomNumberInput
                CheckInfo={GetCrewNumberInputCheckData('')}
                inputValue={crewNumber}
                setValue={setCrewNumber}
              />

              <Text mt={4}>乗務員名*</Text>
              <CustomStringInput
                CheckInfo={GetCrewNameInputCheckData('')}
                inputValue={crewName}
                setValue={setCrewName}
                PhohibitionCharaCheck={false}
              />

              <Text mt={4}>フリガナ</Text>
              <CustomStringInput
                CheckInfo={GetFuriganaInputCheckData('')}
                inputValue={furigana}
                setValue={setFurigana}
                PhohibitionCharaCheck={false}
              />

              <Text mt={4}>パスワード*</Text>
              <CustomStringInput
                CheckInfo={GetPasswordInputCheckData('')}
                inputValue={password}
                setValue={setPassword}
                PhohibitionCharaCheck={false}
              />

              <Text mt={4}>確認パスワード*</Text>
              <CustomStringInput
                CheckInfo={GetPasswordInputCheckData('')}
                inputValue={checkPassword}
                setValue={setCheckPassword}
                PhohibitionCharaCheck={false}
              />

              <Text mt={4}>管理権限*</Text>
              <Select
                mt={2}
                w='20%'
                onChange={(e) => {
                  setRole(Number(e.target.value));
                }}
              >
                <option value='1'>マスタメンテ</option>
                <option value='2'>通知</option>
                <option value='3'>閲覧</option>
                <option value='0'>利用停止</option>
              </Select>
            </Box>
            <Button
              mt={10}
              onClick={() => {
                CreateApi();
              }}
            >
              作成
            </Button>
            <Button mt={10} ml={10} onClick={() => onClose()}>
              取り消す
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default React.memo(AdminUsersCreateWindow);
